
import { useState } from "react";
import { ColumnId, SortState } from "./PartTableHeader";
import { Part } from "@/data/parts";

export const useTableSort = () => {
  // State to track sorting - default to rating descending
  const [sortState, setSortState] = useState<SortState>({ column: "rating", direction: "desc" });
  
  // Handle column header click for sorting
  const handleSort = (columnId: ColumnId) => {
    let newDirection: "asc" | "desc" | null = 'asc';
    
    // If already sorting by this column, toggle direction or clear sort
    if (sortState.column === columnId) {
      if (sortState.direction === 'asc') {
        newDirection = 'desc';
      } else if (sortState.direction === 'desc') {
        newDirection = null;
      }
    }
    
    setSortState({
      column: newDirection ? columnId : null,
      direction: newDirection
    });
  };
  
  // Count the number of true requirements for a part
  const countRequirements = (part: Part): number => {
    let count = 0;
    if (part.requiresRoot) count++;
    if (part.requiresWiring) count++;
    if (part.requiresPrinting) count++;
    if (part.requiresTools) count++;
    if (part.requiresPurchase) count++;
    return count;
  };
  
  // Function to sort parts based on current sort state
  const getSortedParts = (parts: Part[]) => {
    if (!sortState.column || !sortState.direction) {
      return parts;
    }
    
    return [...parts].sort((a, b) => {
      const multiplier = sortState.direction === 'asc' ? 1 : -1;
      
      switch (sortState.column) {
        case 'name':
          return a.name.localeCompare(b.name) * multiplier;
        case 'category':
          return a.category.localeCompare(b.category) * multiplier;
        case 'type':
          return a.subcategory.localeCompare(b.subcategory) * multiplier;
        case 'rating':
          return (a.rating - b.rating) * multiplier;
        // Add complexity/requirements handling - sort by count of requirements
        case 'complexity':
          return (countRequirements(a) - countRequirements(b)) * multiplier;
        default:
          return 0;
      }
    });
  };
  
  return {
    sortState,
    handleSort,
    getSortedParts
  };
};
